export const contactsData = {
    email: 'bisratyalew999@gmail.com',
    phone: '+251929956337',
    address: 'Bole, Addis Ababa, Ethiopia',

    sheetAPI: ''
}